/* ============================================================================
   LoveMeble — Opcje produktu: kolor nóżek + strona narożnika (samodzielny moduł)
   Renderuje pod materiałami na karcie produktu:
     • "Strona narożnika" (Lewostronny / Prawostronny) — TYLKO dla typu "Narożnik"
     • "Kolor nóżek" — dla mebli, które mają przypisane nóżki (pole "nozki")
   Dane bierze z window.LoveMebleProducts (to samo źródło co aplikacja).
   - kafelki i zaznaczenie 1:1 jak przy materiałach
   - wymaga wyboru przed dodaniem do koszyka (jeśli opcja dotyczy tego mebla)
   - zapisuje wybór jako właściwość pozycji ("Kolor nóżek" / "Strona narożnika")
     -> widać w zamówieniu i mailach
   Wgraj jako osobny plik i dołącz w motywie PO app.js:
     <script src="{{ 'lovemeble-nozki.js' | asset_url }}" defer></script>
   ============================================================================ */
(function () {
  "use strict";
  if (window.__lmNozkiInit) return; window.__lmNozkiInit = true;

  var byHandle = {};      // handle -> product
  var feedReady = false;

  window.__lmLeg  = { present: false, required: true, name: null, variantIds: [] };
  window.__lmSide = { present: false, required: true, name: null, variantIds: [] };

  /* --- styl ---
     Reużywamy klas motywu (.pd-opt-lbl, .opt-vals.mat-opts--grouped, .mat-group,
     .mat-group-h, .mat-group-row, .opt-btn, .mat-swatch.has-image) -> kafelek
     i stan zaznaczenia (czarna obwódka) są 1:1 jak przy materiałach.
     Poniżej tylko drobne różnice, żeby było jasne, że to WYBÓR NÓŻEK: linia
     oddzielająca u góry i czerwona kropka-akcent przy nagłówku. Rząd kafelków
     to ta sama karuzela (poziome przewijanie) co przy materiałach. */
  (function injectCSS() {
    var s = document.createElement("style");
    s.textContent =
      '.lm-legs{margin:22px 0 4px;padding-top:20px;border-top:1px solid var(--border,#e8e8e8)}' +
      '.lm-opt-ico{display:inline-block;width:17px;height:17px;vertical-align:-3px;margin-right:8px;color:var(--red,#B62643)}' +
      // --- sekcja strony narożnika: WŁASNY layout (nie dziedziczy kontenerów motywu) ---
      '.lm-side-h{font-family:var(--fb,"DM Sans",sans-serif);font-size:11px;font-weight:700;color:var(--muted,#8a8a8a);text-transform:uppercase;letter-spacing:.08em;margin:0 0 14px;padding-bottom:8px;border-bottom:1px solid var(--border,#e8e8e8)}' +
      '.lm-side-body{display:flex;gap:16px;align-items:stretch;flex-wrap:wrap}' +
      '.lm-side-row{display:flex;gap:12px;flex:0 0 auto}' +
      '.lm-side-btn{width:140px;display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px 10px 10px;border:1.5px solid var(--border,#e8e8e8);background:#fff;border-radius:10px;font-family:var(--fb,"DM Sans",sans-serif);font-size:12px;font-weight:600;color:var(--g600,#4a444a);cursor:pointer;transition:.2s}' +
      '.lm-side-btn:hover{border-color:var(--black,#0f0f0f);color:var(--black,#0f0f0f)}' +
      '.lm-side-btn.on{border-color:var(--black,#0f0f0f);box-shadow:0 0 0 1.5px var(--black,#0f0f0f)}' +
      '.lm-side-tile{width:100%;height:60px;display:flex;align-items:center;justify-content:center;overflow:hidden}' +
      '.lm-side-tile img{max-width:100%;max-height:100%;display:block}' +
      '.lm-mirror{transform:scaleX(-1)}' +
      '.lm-side-note{font-family:var(--fb,"DM Sans",sans-serif);font-size:12px;line-height:1.4;color:#6f4a51;margin:0;display:flex;gap:9px;align-items:center;flex:1 1 220px;min-width:200px;background:#fbeef2;border:1px solid #f2d6dd;border-radius:10px;padding:10px 16px;box-sizing:border-box}' +
      '.lm-side-note svg{flex:0 0 auto;width:16px;height:16px;color:var(--red,#B62643)}' +
      '.lm-side-note span{flex:1 1 auto;min-width:0}' +
      '@media(max-width:600px){' +
        '.lm-side-row{flex-basis:100%;width:100%;gap:10px}' +
        '.lm-side-btn{flex:1 1 0;width:auto}' +
        '.lm-side-note{flex-basis:100%}' +
      '}' +
      '.lm-legs.lm-flash{animation:lmLegFlash .5s ease}' +
      '@keyframes lmLegFlash{0%,100%{background:transparent}30%{background:#fbeef2}}';
    document.head.appendChild(s);
  })();

  /* --- dane produktów ---
     Bierzemy je z tego samego źródła co aplikacja: window.LoveMebleProducts
     (wstrzykiwane inline przez motyw). To pewniejsze niż osobny fetch —
     dane są już na stronie i zawierają pole "nozki". */
  function loadData() {
    var arr = Array.isArray(window.LoveMebleProducts) ? window.LoveMebleProducts : null;
    if (!arr) {                       // skrypt wystartował przed danymi — poczekaj chwilę
      loadData._n = (loadData._n || 0) + 1;
      if (loadData._n < 60) setTimeout(loadData, 100);   // do ~6 s
      return;
    }
    byHandle = {};
    arr.forEach(function (p) { if (p && p.id != null) byHandle[p.id] = p; }); // p.id = handle
    feedReady = true;
    renderExtras();
  }

  /* --- ikony (liniowe, dziedziczą kolor przez currentColor) --- */
  var LEG_ICO = '<svg class="lm-opt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M7 7 4 20"/><path d="M17 7l3 13"/></svg>';
  var MAT_ICO = '<svg class="lm-opt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3s-7 8-7 12a7 7 0 0 0 14 0c0-4-7-12-7-12Z"/></svg>';
  var SIDE_ICO = '<svg class="lm-opt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 4v16h15"/><path d="M5 12h8v8"/></svg>';
  // ilustracja narożnika = Twój wektor cat-naroznik.svg z motywu; URL budujemy z własnej ścieżki skryptu
  var SOFA_URL = (function () {
    var sc = document.currentScript || document.querySelector('script[src*="lovemeble-nozki"]');
    var b = sc && sc.src ? sc.src.replace(/[^\/]*$/, "") : "";
    return b ? b + "cat-naroznik.svg" : "";
  })();
  var INFO_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 8h.01"/></svg>';

  /* Doczepia ikonę „materiał/kolor" do etykiety materiałów (renderowanej przez
     aplikację). Idempotentne — nie dubluje, odnawiane przez obserwator. */
  function decorateMaterialLabel() {
    var sel = document.getElementById("mat-selected");
    var lbl = sel ? sel.parentNode : null;
    if (!lbl || lbl.querySelector(".lm-opt-ico")) return;
    lbl.insertAdjacentHTML("afterbegin", MAT_ICO);
  }

  function currentHandle() {
    var m = (location.pathname || "").match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function onProductPage() { return /\/products\//.test(location.pathname || ""); }

  function flashEl(id) {
    var el = document.getElementById(id);
    if (!el) return;
    try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
    el.classList.remove("lm-flash"); void el.offsetWidth; el.classList.add("lm-flash");
  }
  window.__lmLegFlash = function () { flashEl("lm-legs"); };

  function variantIdsOf(prod) {
    var v = [];
    (prod.variants || []).forEach(function (x) { if (x && x.id != null) v.push(Number(x.id)); });
    return v;
  }

  /* --- główny render: nóżki + strona narożnika ---
     Wstawiamy najpierw stronę, potem nóżki — a że oba idą zaraz PO materiałach,
     nóżki lądują nad stroną. Kolejność na stronie: materiały → nóżki → strona narożnika. */
  function renderExtras() {
    var box = document.getElementById("mat-opts");
    if (!box) return;
    decorateMaterialLabel();   // ikona przy „Materiał / Kolor"

    var oL = document.getElementById("lm-legs"); if (oL && oL.parentNode) oL.parentNode.removeChild(oL);
    var oS = document.getElementById("lm-side"); if (oS && oS.parentNode) oS.parentNode.removeChild(oS);
    window.__lmLeg  = { present: false, required: true, name: null, variantIds: [] };
    window.__lmSide = { present: false, required: true, name: null, variantIds: [] };
    if (!onProductPage() || !feedReady) return;

    var prod = byHandle[currentHandle()];
    if (!prod) return;

    renderSide(box, prod);   // najpierw wstawiamy stronę -> wyląduje NIŻEJ
    renderLegs(box, prod);   // potem nóżki -> tuż pod materiałami, NAD stroną narożnika
  }

  /* --- sekcja: kolor nóżek --- */
  function renderLegs(box, prod) {
    var legs = Array.isArray(prod.nozki) ? prod.nozki.filter(function (x) { return x && x.name; }) : [];
    if (!legs.length) return;

    // stała kolejność na stronie — niezależna od kolejności zaznaczenia w panelu
    var ORDER = ["Natura", "Olcha", "Orzech", "Mahoń", "Wenge", "Biały", "Czarny", "Srebrny", "Złoty"];
    legs.sort(function (a, b) {
      var ia = ORDER.indexOf(a.name); if (ia < 0) ia = 999;
      var ib = ORDER.indexOf(b.name); if (ib < 0) ib = 999;
      return (ia - ib) || String(a.name).localeCompare(String(b.name), "pl");
    });

    window.__lmLeg = { present: true, required: true, name: null, variantIds: variantIdsOf(prod) };

    var rows = legs.map(function (l) {
      var sw = l.img
        ? "background-image:url('" + String(l.img).replace(/'/g, "%27") + "');background-size:cover;background-position:center"
        : "background:#d8d2c8";
      return '<button type="button" class="opt-btn lm-leg-btn" data-leg="' + escAttr(l.name) + '">' +
        '<div class="mat-swatch has-image" style="' + sw + '"></div>' +
        escHtml(l.name) + '</button>';
    }).join("");

    var wrap = document.createElement("div");
    wrap.className = "lm-legs";
    wrap.id = "lm-legs";
    wrap.innerHTML =
      '<p class="pd-opt-lbl">' + LEG_ICO + 'Nóżki — <span id="lm-legs-cur" style="font-weight:700;color:var(--black);text-transform:none;letter-spacing:0">Wybierz kolor</span></p>' +
      '<div class="opt-vals mat-opts--grouped">' +
        '<div class="mat-group">' +
          '<div class="mat-group-h">Wykończenie nóżek</div>' +
          '<div class="mat-group-row lm-legs-row">' + rows + '</div>' +
        '</div>' +
      '</div>';
    box.parentNode.insertBefore(wrap, box.nextSibling);

    wrap.querySelectorAll(".lm-leg-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        wrap.querySelectorAll(".lm-leg-btn").forEach(function (b) { b.classList.remove("on"); });
        btn.classList.add("on");
        window.__lmLeg.name = btn.getAttribute("data-leg");
        var cur = document.getElementById("lm-legs-cur");
        if (cur) cur.textContent = window.__lmLeg.name;
      });
    });
  }

  /* --- sekcja: strona narożnika ---
     Pokazywana tylko, gdy w produkcie włączysz metapole „Strona narożnika"
     (custom.wybor_strony = true). Dzięki temu sam decydujesz, na których
     narożnikach ma się pojawić (np. tylko na uniwersalnych). */
  function renderSide(box, prod) {
    if (prod.strona !== true) return;

    window.__lmSide = { present: true, required: true, name: null, variantIds: variantIdsOf(prod) };

    var opts = [ { name: "Lewostronny", mirror: true }, { name: "Prawostronny", mirror: false } ];
    var rows = opts.map(function (o) {
      return '<button type="button" class="opt-btn lm-side-btn" data-side="' + escAttr(o.name) + '">' +
        '<div class="lm-side-tile"><img src="' + SOFA_URL + '" alt="" class="' + (o.mirror ? 'lm-mirror' : '') + '"></div>' +
        escHtml(o.name) + '</button>';
    }).join("");

    var wrap = document.createElement("div");
    wrap.className = "lm-legs lm-side";
    wrap.id = "lm-side";
    wrap.innerHTML =
      '<p class="pd-opt-lbl">' + SIDE_ICO + 'Strona narożnika — <span id="lm-side-cur" style="font-weight:700;color:var(--black);text-transform:none;letter-spacing:0">Wybierz stronę</span></p>' +
      '<div class="lm-side-wrap">' +
        '<div class="lm-side-h">Ustawienie narożnika</div>' +
          '<div class="lm-side-body">' +
            '<div class="lm-side-row">' + rows + '</div>' +
            '<p class="lm-side-note">' + INFO_ICO + '<span>Narożnik jest uniwersalny — stronę możesz w każdej chwili przełożyć samodzielnie. Dla wygody przygotujemy go od razu pod wybraną stronę.</span></p>' +
          '</div>' +
      '</div>';
    box.parentNode.insertBefore(wrap, box.nextSibling);

    wrap.querySelectorAll(".lm-side-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        wrap.querySelectorAll(".lm-side-btn").forEach(function (b) { b.classList.remove("on"); });
        btn.classList.add("on");
        window.__lmSide.name = btn.getAttribute("data-side");
        var cur = document.getElementById("lm-side-cur");
        if (cur) cur.textContent = window.__lmSide.name;
      });
    });
  }

  /* --- aktywne opcje tego produktu (do walidacji i zapisu na pozycji) --- */
  function activeOpts() {
    var list = [];
    if (window.__lmLeg && window.__lmLeg.present)
      list.push({ o: window.__lmLeg, prop: "Kolor nóżek", err: "Wybierz kolor nóżek przed dodaniem do koszyka.", flash: "lm-legs" });
    if (window.__lmSide && window.__lmSide.present)
      list.push({ o: window.__lmSide, prop: "Strona narożnika", err: "Wybierz stronę narożnika przed dodaniem do koszyka.", flash: "lm-side" });
    return list;
  }

  /* --- doczepienie właściwości do /cart/add.js + wymóg wyboru --- */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === "string" ? input : (input && input.url)) || "";
      if (init && init.body && /\/cart\/add(\.js)?/.test(url) && onProductPage() && typeof init.body === "string") {
        var opts = activeOpts();
        if (opts.length) {
          var body = JSON.parse(init.body);
          var items = body.items ? body.items : (body.id != null ? [body] : null);
          if (items) {
            // 1) walidacja: każda wymagana opcja dotycząca dodawanego wariantu musi być wybrana
            for (var k = 0; k < opts.length; k++) {
              var op = opts[k];
              var touches = items.some(function (it) { return op.o.variantIds.indexOf(Number(it.id)) > -1; });
              if (touches && op.o.required && !op.o.name) {
                flashEl(op.flash);
                return Promise.resolve(new Response(
                  JSON.stringify({ status: 422, description: op.err }),
                  { status: 422, headers: { "Content-Type": "application/json" } }
                ));
              }
            }
            // 2) zapis wybranych właściwości na pozycji
            items.forEach(function (it) {
              opts.forEach(function (op) {
                if (op.o.name && op.o.variantIds.indexOf(Number(it.id)) > -1) {
                  it.properties = it.properties || {};
                  it.properties[op.prop] = op.o.name;
                }
              });
            });
            if (body.items) body.items = items; else body = items[0];
            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }
        }
      }
    } catch (e) {}
    return _fetch.call(this, input, init);
  };

  /* --- reakcja na zmianę produktu (SPA) --- */
  function watch() {
    var box = document.getElementById("mat-opts");
    if (!box) { setTimeout(watch, 400); return; }
    var mo = new MutationObserver(function () { renderExtras(); });
    mo.observe(box, { childList: true });
    window.addEventListener("popstate", function () { setTimeout(renderExtras, 60); });
    renderExtras();
  }

  /* --- helpers --- */
  function escHtml(s) { return String(s == null ? "" : s).replace(/[&<>]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]; }); }
  function escAttr(s) { return String(s == null ? "" : s).replace(/"/g, "&quot;"); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { loadData(); watch(); });
  else { loadData(); watch(); }
})();